import { BadgeType } from "components/atoms/Badge/Badge";

const QuoteStatusColors: Record<string, BadgeType> = {
  "Open for quotations": "primary",
  "Closed for quotations": "warning",
  "Awaiting action": "danger",
  Draft: "secondary",
  archived: "secondary",
};

export default QuoteStatusColors;
